function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 38 29",
  fill: "none"
}, props),
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0h14.908c1.604 0 3.04.722 4 1.858a5.224 5.224 0 014-1.858h14.907v26.22H20.143v2.158h-2.47V26.22H0V0zm20.143 23.75V5.235a2.765 2.765 0 012.765-2.765h12.437v21.28H20.143zM2.47 2.47v21.28h15.203V5.235a2.765 2.765 0 00-2.765-2.765H2.47zm30.744 6.362h-10.94v-2.47h10.94v2.47zm-10.94 5.937h8.415V12.3h-8.417v2.47z",
  fill: "#354147"
})));